import classes from '../Classes';
import options from '../../../../constants/carouselOptions.js';

/**
 * Layout style handler for the alignment of text in a SliderCard.
 * The values are taken for "Text alignment", "Text placement", and "Text vertical alignment" in "Carousel Options" entry.
 * @param {Object} textConf - Configuration object containing text alignment properties.
 * @param {string} textConf.textAlignment - The alignment of the text (left, center, right).
 * @param {string} textConf.textPlacement - The placement of the text (left, center, right).
 * @param {string} textConf.textVerticalAlignment - The vertical alignment of the text (top, center, bottom, space-between).
 * @returns {Object} An object containing methods to get the alignment classes.
 */
var layoutStyle = function layoutStyle(textConf) {
  return {
    getGridAlignment: function getGridAlignment() {
      if (textConf.textPlacement === options.TEXT_PLACEMENT.LEFT) {
        return classes.GRID_ALIGNMENT.START;
      }
      if (textConf.textPlacement === options.TEXT_PLACEMENT.CENTER) {
        return classes.GRID_ALIGNMENT.CENTER;
      }
      if (textConf.textPlacement === options.TEXT_PLACEMENT.RIGHT) {
        return classes.GRID_ALIGNMENT.END;
      }
      return classes.GRID_ALIGNMENT.START; // Default case
    },

    getAlignment: function getAlignment() {
      if (textConf.textAlignment === options.TEXT_PLACEMENT.LEFT) {
        return classes.ALIGNMENT.LEFT;
      }
      if (textConf.textAlignment === options.TEXT_PLACEMENT.CENTER) {
        return classes.ALIGNMENT.CENTER;
      }
      if (textConf.textAlignment === options.TEXT_PLACEMENT.RIGHT) {
        return classes.ALIGNMENT.RIGHT;
      }
      return classes.ALIGNMENT.LEFT; // Default case
    },

    getVerticalAlignment: function getVerticalAlignment() {
      if (textConf.textVerticalAlignment === options.VERTICAL_ALIGNMENT.SPACE_BETWEEN) {
        return classes.VERTICAL_ALIGNMENT.SPACE_BETWEEN;
      }
      if (textConf.textVerticalAlignment === options.VERTICAL_ALIGNMENT.TOP) {
        return classes.VERTICAL_ALIGNMENT.TOP;
      }
      if (textConf.textVerticalAlignment === options.VERTICAL_ALIGNMENT.BOTTOM) {
        return classes.VERTICAL_ALIGNMENT.BOTTOM;
      }
      return classes.VERTICAL_ALIGNMENT.CENTER; // Default case
    }
  };
};

export default layoutStyle;